/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/aria-proptypes */

import classNames from 'classnames';
import { get, head } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';
import { ValidationMessage } from 'web-ui-components/lib/molecules/forms';
import { ChapsPaymentLimitsModal } from '../../chaps/components/ChapsPayments/ChapsPaymentLimitsModal';
import { invalidBatchNameCharactersRegex } from '../../config';
import PaymentLimitsModal from '../../fasterPayments/components/Payments/PaymentLimitsModal';
import PaymentListHeader from '../../fasterPayments/components/Payments/PaymentListHeader';
import PaymentRepeating from '../../fasterPayments/components/Payments/PaymentRepeating';
import PaymentsBatchToggle from '../../fasterPayments/components/Payments/PaymentsBatchToggle';
import { fixAmount } from '../../helpers/fieldHelpers';
import { fromAccountPropType, toAccountPropType } from '../../states/accounts/propTypes';
import payeePropTypes from '../../states/payees/propTypes';
import AddMoreButton from '../AddMoreButton';
import DeleteTemplate from '../DeleteTemplate/DeleteTemplate';
import TemplateName from '../TemplateName/TemplateName';

export const cleanBatchName = (batchName) => batchName.replace(invalidBatchNameCharactersRegex, '');

export const shouldProgressReveal = ({
	showToPayeeList,
	isMultiplePayments,
	isMultiTransactions,
	paymentsHaveFromAndToAccount,
	templateMode,
}) => {
	if (showToPayeeList) {
		return true;
	}

	if (isMultiplePayments || isMultiTransactions || templateMode) {
		return false;
	}

	return !paymentsHaveFromAndToAccount;
};

const StyledHeaderRow = styled('div')`
	display: flex;
	justify-content: space-between;
`;

const PaymentListLayout = (props) => {
	const {
		payments,
		showAddNewPaymentButton,
		isMultiplePayments,
		paymentsHaveFromAndToAccount,
		hasPaymentCapability,
		isNumberOfPaymentsLimit,
		content,
		frequencyLabel,
		firstPaymentLabel,
		stopPaymentLabel,
		stopOnNumberLabel,
		stopOnDateLabel,
		isBatch,
		handleToggleIsBatch,
		batchName,
		handleBatchNameChanged,
		isBatchEligible,
		paymentsTotal,
		isAuthorisationEdit,
		toAccounts,
		fromAccounts,
		toPayees,
		isRepeatingPayment,
		allowApplySameForAll,
		isMultiTransactions,
		isFormValid,
		isBatchLimitExceeded,
		showErrors,
		showToPayeeList,
		showValidation,
		handleToCardClick,
		handleFromCardClick,
		templateMode,
		templateId,
		templateName,
		handleDeleteTemplate,
		isManagePaymentEdit,
		handleAddMore,
		typeTooltipHelpOpen,
		refTooltipHelpOpen,
		showSameRefPopover,
		showSameDatePopover,
		handleReferenceTooltip,
		handleTypeTooltip,
		handleSameRef,
		handleSameDate,
		copyFirstDateToAll,
		copyFirstRefToAll,
		copyRefToAll,
		copyDateToAll,
		updateActiveRow,
		activeRowId,
		chapsMode,
		PaymentComponent,
		isLongRef,
		referenceMaxLength,
		hasTransactionLimitError,
		maxDate,
		isChapsEditing,
		paymentDates,
		cleanIllegalCharacters,
		isPaymentEdit,
	} = props;

	const { fromLabel, toLabel, amtLabel, refLabel, dateLabel, typeLabel, templateAmtLabel, templateRefLabel } = content;
	const paymentLabels = {
		fromLabel,
		toLabel,
		amtLabel: templateMode ? templateAmtLabel : amtLabel,
		refLabel: templateMode ? templateRefLabel : refLabel,
		dateLabel,
		typeLabel,
	};

	const renderBatchToggle = () => {
		if (isRepeatingPayment || payments.length < 2) return null;
		const disabled = isAuthorisationEdit || !isBatchEligible;

		return (
			<PaymentsBatchToggle
				isBatch={isBatch}
				handleToggleIsBatch={handleToggleIsBatch}
				handleBatchNameChanged={handleBatchNameChanged}
				batchName={batchName}
				disabled={disabled}
				batchToggleLabel={content.batchToggleLabel}
				batchToggleLabelSubText={content.batchToggleLabelSubText}
				batchPaymentNameLabel={content.batchPaymentNameLabel}
				batchPaymentNameLabelSubText={content.batchPaymentNameLabelSubText}
				batchToggleMoreText={content.batchToggleMoreText}
				disabledBatchText={content.disabledBatchText}
				isEdit={isAuthorisationEdit || isChapsEditing}
				editBatchMessage={content.editBatchMessage}
			/>
		);
	};

	const renderRepeating = (payment, labels) => {
		if (chapsMode || get(payment, 'type', '') !== 'repeating') return null;
		return (
			<div className="c-o-list-payment__wrap">
				<PaymentRepeating key={`repeating${payment.id}`} {...payment} {...labels} content={content} />{' '}
			</div>
		);
	};

	const showRemoveButton = isMultiplePayments && (!(isAuthorisationEdit || isChapsEditing) || payments.length > 2);
	const progressiveReveal = shouldProgressReveal(props);
	const showType = !isAuthorisationEdit && !isMultiplePayments && !isMultiTransactions && !templateMode && !chapsMode;
	const allowDateApplySameForAll = allowApplySameForAll && !isAuthorisationEdit && !(isChapsEditing && isBatch);
	const isCreatedFromTemplate = !templateMode && !!templateId;

	return (
		<div>
			{hasPaymentCapability && (
				<div
					className={classNames({
						'c-o-payee-list--to-state': showToPayeeList,
						'c-o-payee-list--to-state--relative': showToPayeeList,
					})}
				>
					<div
						className={classNames('c-o-list-payment', {
							'c-o-list-payment--progressive-reveal': progressiveReveal,
							'c-o-list-payment--multi': allowDateApplySameForAll || allowApplySameForAll,
							'c-o-list-payment--no-type': !showType,
						})}
					>
						<div className="c-o-list-payment__card c-o-card c-o-card--muted c-o-card--bordered">
							<StyledHeaderRow>
								{templateMode && <TemplateName />}
								{templateMode && templateId && <DeleteTemplate handleDeleteTemplate={handleDeleteTemplate} />}
							</StyledHeaderRow>
							{isCreatedFromTemplate && (
								<p>
									<strong>{templateName}</strong>
								</p>
							)}
							<div className="c-o-list-payment__wrap">
								<PaymentListHeader
									fromLabel={fromLabel}
									toLabel={toLabel}
									amtLabel={templateMode ? templateAmtLabel : amtLabel}
									refLabel={templateMode ? templateRefLabel : refLabel}
									dateLabel={dateLabel}
									typeLabel={typeLabel}
									showType={showType}
									allowApplySameForAll={allowApplySameForAll}
									content={content}
									isAuthorisationEdit={isAuthorisationEdit}
									typeTooltipHelpOpen={typeTooltipHelpOpen}
									refTooltipHelpOpen={refTooltipHelpOpen}
									showSameRefPopover={showSameRefPopover}
									showSameDatePopover={showSameDatePopover}
									handleReferenceTooltipClick={handleReferenceTooltip}
									handleTypeTooltipClick={handleTypeTooltip}
									handleSameRefClick={handleSameRef}
									handleSameDateClick={handleSameDate}
									copyDateToAll={copyFirstDateToAll}
									copyRefToAll={copyFirstRefToAll}
									allowDateApplySameForAll={allowDateApplySameForAll}
									showDate={!templateMode}
									showRefHelp={!templateMode}
								/>

								{payments.map((payment, index) => {
									const getBiocatchIdentifier = payments.length > 1 ? `payment-amount-${index}` : 'payment-amount-0';

									return (
										<PaymentComponent
											key={payment.id}
											{...payment}
											{...paymentLabels}
											disablePaymentType={isMultiplePayments || isManagePaymentEdit}
											showRemoveButton={showRemoveButton}
											showValidation={showValidation}
											updateAllOnChange={(isAuthorisationEdit || isChapsEditing) && isBatch}
											handleToCardClick={handleToCardClick}
											toPayees={toPayees}
											fromAccounts={fromAccounts}
											toAccounts={toAccounts}
											handleFromCardClick={handleFromCardClick}
											copyRefToAll={allowApplySameForAll ? copyRefToAll : null}
											copyDateToAll={allowApplySameForAll ? copyDateToAll : null}
											refTooltipHelpOpen={refTooltipHelpOpen}
											handleReferenceTooltip={handleReferenceTooltip}
											handleTypeTooltip={handleTypeTooltip}
											typeTooltipHelpOpen={typeTooltipHelpOpen}
											showType={showType}
											isActiveRow={activeRowId === payment.id}
											updateActiveRow={updateActiveRow}
											isAuthorisationEdit={isAuthorisationEdit}
											templateMode={templateMode}
											showDate={!templateMode}
											isManagePaymentEdit={isManagePaymentEdit}
											isLongRef={isLongRef}
											referenceMaxLength={referenceMaxLength}
											hasTransactionLimitError={hasTransactionLimitError}
											maxDate={maxDate}
											chapsMode={chapsMode}
											paymentDates={paymentDates}
											cleanIllegalCharacters={cleanIllegalCharacters}
											isPaymentEdit={isPaymentEdit}
											biocatchIdentifier={getBiocatchIdentifier}
										/>
									);
								})}
							</div>

							{!progressiveReveal &&
								renderRepeating(head(payments), {
									frequencyLabel,
									firstPaymentLabel,
									stopPaymentLabel,
									stopOnNumberLabel,
									stopOnDateLabel,
								})}
							<div className="c-o-list-payment__footer">
								{isBatch && (
									<div className="c-o-list-payment__total has-total-row" id="batch-total">
										<span className="c-o-list-payment__total-label">Total</span>
										<span className="c-o-list-payment__total-value">
											&pound;
											{fixAmount(paymentsTotal)}
										</span>
									</div>
								)}
								{showAddNewPaymentButton && (
									<AddMoreButton
										onClick={() => handleAddMore(payments)}
										isDisabled={!paymentsHaveFromAndToAccount}
										title={content.addButton}
									/>
								)}
							</div>
							{isNumberOfPaymentsLimit && <p id="payment-limit-msg">{content.paymentsLimitMessage}</p>}
							{!isFormValid && showErrors && (
								<div id="invalid-msg">
									<ValidationMessage value={content.invalidFormMsg} />
								</div>
							)}
							{isBatch && isBatchLimitExceeded && (
								<p className="u-color-utility-error" id="batch-Limit-exceeded-msg">
									{content.maxLimitExceededMessage}
								</p>
							)}
						</div>
						{!progressiveReveal && !templateMode && renderBatchToggle(head(payments))}
						{chapsMode ? <ChapsPaymentLimitsModal /> : <PaymentLimitsModal />}
					</div>
				</div>
			)}
		</div>
	);
};

PaymentListLayout.propTypes = {
	payments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	showAddNewPaymentButton: PropTypes.bool.isRequired,
	isMultiplePayments: PropTypes.bool.isRequired,
	paymentsHaveFromAndToAccount: PropTypes.bool.isRequired,
	isNumberOfPaymentsLimit: PropTypes.bool,
	hasPaymentCapability: PropTypes.bool.isRequired,
	content: PropTypes.shape({}).isRequired,
	frequencyLabel: PropTypes.string,
	firstPaymentLabel: PropTypes.string,
	stopPaymentLabel: PropTypes.string,
	stopOnNumberLabel: PropTypes.string,
	stopOnDateLabel: PropTypes.string,
	isBatch: PropTypes.bool,
	batchName: PropTypes.string,
	handleToggleIsBatch: PropTypes.func,
	handleBatchNameChanged: PropTypes.func.isRequired,
	isBatchEligible: PropTypes.bool,
	paymentsTotal: PropTypes.string,
	isFormValid: PropTypes.bool.isRequired,
	isAuthorisationEdit: PropTypes.bool.isRequired,
	toAccounts: PropTypes.arrayOf(PropTypes.shape(toAccountPropType)).isRequired,
	fromAccounts: PropTypes.arrayOf(PropTypes.shape(fromAccountPropType)).isRequired,
	toPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)).isRequired,
	isRepeatingPayment: PropTypes.bool,
	allowApplySameForAll: PropTypes.bool.isRequired,
	isMultiTransactions: PropTypes.bool.isRequired,
	isBatchLimitExceeded: PropTypes.bool,
	showErrors: PropTypes.bool.isRequired,
	showToPayeeList: PropTypes.bool.isRequired,
	showValidation: PropTypes.bool,
	handleToCardClick: PropTypes.func.isRequired,
	handleFromCardClick: PropTypes.func,
	templateMode: PropTypes.bool,
	validations: PropTypes.shape({}),
	handleDeleteTemplate: PropTypes.func,
	templateId: PropTypes.string,
	templateName: PropTypes.string,
	isManagePaymentEdit: PropTypes.bool.isRequired,
	handleAddMore: PropTypes.func,
	typeTooltipHelpOpen: PropTypes.bool,
	refTooltipHelpOpen: PropTypes.bool,
	showSameRefPopover: PropTypes.bool,
	showSameDatePopover: PropTypes.bool,
	handleReferenceTooltip: PropTypes.func,
	handleTypeTooltip: PropTypes.func,
	handleSameRef: PropTypes.func,
	handleSameDate: PropTypes.func,
	copyFirstDateToAll: PropTypes.func,
	copyFirstRefToAll: PropTypes.func,
	copyRefToAll: PropTypes.func,
	copyDateToAll: PropTypes.func,
	updateActiveRow: PropTypes.func,
	activeRowId: PropTypes.string,
	chapsMode: PropTypes.bool,
	PaymentComponent: PropTypes.func.isRequired,
	isLongRef: PropTypes.bool,
	referenceMaxLength: PropTypes.string,
	hasTransactionLimitError: PropTypes.func,
	maxDate: PropTypes.shape({}),
	isChapsEditing: PropTypes.bool,
	paymentDates: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
	cleanIllegalCharacters: PropTypes.func,
};
export default PaymentListLayout;
